<template>
  <div id='bd-main'>
    <el-table :data="userStatuses.content" border style="width: 100%" highlight-current-row>
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column prop="user.nickname" label="姓名" width="185"></el-table-column>
      <el-table-column prop="status" label="状态"></el-table-column>
      <el-table-column prop="client" label="客户端"></el-table-column>
      <el-table-column prop="createdAt" label="时间"></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="10"
      @current-change="handleCurrentChange"
      layout="total, prev, pager, next"
      :total="userStatuses.totalElements">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'bd-main',
  data () {
    return {
      resize: true
    }
  },
  computed: {
    ...mapGetters([ 'userStatuses' ])
  },
  methods: {
    ...mapActions([ 'queryStatuses' ]),
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      let payload = { page: val - 1, size: 10 }
    this.queryStatuses(payload)
    }
  },
  created() {
    let payload = { page: 0, size: 10 }
    this.queryStatuses(payload)
  },

}
</script>

<style scoped>

</style>
